import { Button } from "react-bootstrap";

import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { modalActions } from "../../constants";
import { UserLicenceAssignmentForm } from "./userLicenceAssignmentForm";
import { DataForm } from "..";

export const DataModalBody = ({
	editorSetting,
	currentModalData,
	modalErrors,
	setCurrentModalDataAtIndex,
	setCurrentModalErrorsAtIndex,
	addForm,
}) => {
	switch (editorSetting?.action) {
		case modalActions.MULTI_CREATE:
			return (
				<div className="multi-create">
					{currentModalData.map((formData, index) => (
						<DataForm
							key={index}
							editorSetting={editorSetting}
							currentFormData={formData}
							errors={modalErrors[index]}
							setFormData={setCurrentModalDataAtIndex(index)}
							setErrors={setCurrentModalErrorsAtIndex(index)}
							hasFieldTitle={index === 0}
						/>
					))}
					<Button onClick={addForm} className="mb-2">
						<FontAwesomeIcon icon={faPlus} />
					</Button>
				</div>
			);
		case modalActions.EDIT:
		case modalActions.CREATE:
		case modalActions.DELETE:
		default:
			if (editorSetting?.fields?.length > 0)
				return (
					<DataForm
						editorSetting={editorSetting}
						currentFormData={currentModalData[0]}
						errors={modalErrors[0]}
						setFormData={setCurrentModalDataAtIndex(0)}
						setErrors={setCurrentModalErrorsAtIndex(0)}
					/>
				);
			// TODO: THIS WITH PROPER CSS
			else return <div className="mb-3" />;
		case modalActions.UserLicenceAssignmentForm:
			return (
				<UserLicenceAssignmentForm
					editorSetting={editorSetting}
					setFormData={setCurrentModalDataAtIndex(0)}
					currentFormData={currentModalData[0]}
				/>
			);
	}
};
